import { render, staticRenderFns } from "./ConnectorsTerms.vue?vue&type=template&id=084164e8&"
import script from "./ConnectorsTerms.vue?vue&type=script&lang=js&"
export * from "./ConnectorsTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports